import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Card,
  CardActionArea,
} from '@material-ui/core'

import CONFIG from '../../config'
import Link from '../controls/Link'

import LargeArrowRight from '../../../assets/images/icons/ico_arrow_large.svg'

class LearnMoreCard extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    isMini: PropTypes.bool,
  }

  static defaultProps = {
    isMini: false,
  }

  static styles = (theme) => ({
    learnMoreCard: {
      marginTop: theme.spacing(4),
      '& a': {
        textDecoration: 'none',
        color: 'inherit',
      },
    },
    learnMoreArrowItem: {
      width: 'fit-content',
      background: 'black',
      color: 'white',
      padding: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        '& img': {
          width: theme.spacing(4),
        },
      },
      [theme.breakpoints.up('md')]: {
        '& img': {
          width: theme.spacing(5),
        },
      },
    },
    learnMoreContentItem: {
      background: 'white',
      padding: theme.spacing(2),
      flexGrow: 1,
      color: theme.primary.color,
      fontSize: '16px',
      lineHeight: '22px',
      '& div': {
        fontWeight: 600,
      },
      '& div + div': {
        color: theme.secondary.color,
        fontSize: '14px',
        fontWeight: 400,
      },
    },
    noWrap: {
      flexWrap: 'nowrap',
    },
  })

  render() {
    const { classes, isMini } = this.props
    const elevation = isMini ? 3 : 0

    return (
      <Card elevation={elevation} square className={classes.learnMoreCard}>
        <Link to={CONFIG.blokable.marketingBaseUrl}>
          <CardActionArea>
            <Grid container className={classes.noWrap}>
              <Grid item container className={classes.learnMoreArrowItem} justify="center" alignItems="center">
                <img src={LargeArrowRight} alt="→" />
              </Grid>
              <Grid item container className={classes.learnMoreContentItem} alignItems="center">
                <div>Learn more about Blokable &amp; BlokSense</div>
              </Grid>
            </Grid>
          </CardActionArea>
        </Link>
      </Card>
    )
  }
}

export default withStyles(LearnMoreCard.styles)(LearnMoreCard)
